class GripCheckTool extends HTMLElement {
  constructor() {
    super();
    this.initQuiz();
  }

  initQuiz() {
    this.quiz = this.querySelector('[data-grip-quiz]');
    if (!this.quiz) return;

    this.quizPanel = this.quiz.querySelector('.grip-quiz__panel');
    this.quizScroll = this.quiz.querySelector('[data-grip-quiz-scroll]');
    this.progressBar = this.quiz.querySelector('[data-grip-quiz-progress]');
    this.progressEl = this.quiz.querySelector('.grip-quiz__progress');
    this.stepLabel = this.quiz.querySelector('[data-grip-quiz-step-label]');
    this.backBtn = this.quiz.querySelector('[data-grip-quiz-back]');
    this.questionSteps = Array.from(this.quiz.querySelectorAll('[data-grip-quiz-step]')).filter(
      (step) => step.dataset.gripQuizStep !== 'result'
    );
    this.resultStep = this.quiz.querySelector('[data-grip-quiz-step="result"]');
    this.resultCards = Array.from(this.quiz.querySelectorAll('[data-result-key]'));
    this.openers = Array.from(this.querySelectorAll('[data-grip-quiz-open]'));

    this.answers = [];
    this.history = [];
    this.currentStep = 0;
    this.lastFocused = null;
    this.isInline = this.quiz.hasAttribute('data-grip-quiz-inline');

    this.onKeydown = (event) => {
      if (event.key === 'Escape') this.closeQuiz();
    };

    this.openers.forEach((btn) => btn.addEventListener('click', () => this.openQuiz(btn)));
    this.quiz
      .querySelectorAll('[data-grip-quiz-close]')
      .forEach((el) => el.addEventListener('click', () => this.closeQuiz()));
    this.backBtn?.addEventListener('click', () => this.goBack());
    this.quiz.querySelector('[data-grip-quiz-restart]')?.addEventListener('click', () => this.restart());
    this.quiz
      .querySelectorAll('[data-grip-quiz-answer]')
      .forEach((btn) => btn.addEventListener('click', () => this.answer(btn)));

    if (this.isInline) this.restart({ focus: false });
  }

  openQuiz(trigger) {
    if (!this.quiz || !this.questionSteps.length) return;
    this.lastFocused = trigger || document.activeElement;
    this.quiz.hidden = false;
    void this.quiz.offsetWidth;
    this.quiz.classList.add('is-open');
    document.body.classList.add('grip-quiz-open');
    document.addEventListener('keydown', this.onKeydown);
    this.restart();
    if (typeof trapFocus === 'function') {
      trapFocus(this.quizPanel, this.quizPanel);
    } else {
      this.quizPanel.focus();
    }
  }

  closeQuiz() {
    if (!this.quiz || this.quiz.hidden) return;
    this.quiz.classList.remove('is-open');
    document.body.classList.remove('grip-quiz-open');
    document.removeEventListener('keydown', this.onKeydown);

    const finish = () => {
      this.quiz.hidden = true;
      this.quiz.removeEventListener('transitionend', onEnd);
    };
    const onEnd = (event) => {
      if (event.target === this.quizPanel) finish();
    };
    this.quiz.addEventListener('transitionend', onEnd);
    window.setTimeout(() => {
      if (!this.quiz.classList.contains('is-open')) finish();
    }, 450);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.lastFocused);
    } else {
      this.lastFocused?.focus?.();
    }
  }

  restart({ focus = true } = {}) {
    this.answers = [];
    this.history = [];
    this.currentStep = 0;
    this.showStep(0, { focus });
  }

  showStep(index, { focus = true } = {}) {
    this.currentStep = index;
    this.questionSteps.forEach((step, i) => {
      step.hidden = i !== index;
    });
    if (this.resultStep) this.resultStep.hidden = true;
    if (this.backBtn) this.backBtn.hidden = this.history.length === 0;

    const total = this.questionSteps.length;
    this.updateProgress(total ? Math.max(0.08, index / total) : 0);
    if (this.stepLabel) this.stepLabel.textContent = `Question ${index + 1} of ${total}`;

    if (this.quizScroll) this.quizScroll.scrollTop = 0;
    if (focus) this.questionSteps[index]?.querySelector('[data-grip-quiz-answer]')?.focus();
  }

  answer(btn) {
    this.answers[this.currentStep] = btn.dataset.answer;
    this.answers.length = this.currentStep + 1;
    this.history.push(this.currentStep);

    const next = this.currentStep + 1;
    if (next < this.questionSteps.length) {
      this.showStep(next);
    } else {
      this.showResult();
    }
  }

  goBack() {
    if (!this.history.length) return;
    const previous = this.history.pop();
    this.showStep(previous);
  }

  decide(base, want) {
    if (want === 'comfort') return 'cork';
    if (want === 'both') return 'starter_kit';
    return base === 'base_ok' ? 'sleeve' : 'starter_kit';
  }

  showResult() {
    const key = this.decide(this.answers[0], this.answers[1]);

    let matched = null;
    this.resultCards.forEach((card) => {
      const isMatch = card.dataset.resultKey === key;
      card.hidden = !isMatch;
      if (isMatch) matched = card;
    });
    if (!matched && this.resultCards[0]) this.resultCards[0].hidden = false;

    this.questionSteps.forEach((step) => {
      step.hidden = true;
    });
    if (this.resultStep) this.resultStep.hidden = false;
    if (this.backBtn) this.backBtn.hidden = false;
    this.updateProgress(1);
    if (this.stepLabel) this.stepLabel.textContent = 'Your result';
    if (this.quizScroll) this.quizScroll.scrollTop = 0;
  }

  updateProgress(ratio) {
    const pct = Math.round(Math.min(1, Math.max(0, ratio)) * 100);
    if (this.progressBar) this.progressBar.style.width = `${pct}%`;
    if (this.progressEl) this.progressEl.setAttribute('aria-valuenow', String(pct));
  }
}

customElements.define('grip-check-tool', GripCheckTool);
